module.exports = __webpack_public_path__ + "static/img/tiggy_pictgrid9_800x743.054bd78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tiggy_pictgrid9_800x743.jpg
// module id = Hn6E
// module chunks = 0